import { Tabs as TabsComponent } from "@ui/tabs";

import { SETTINGS_TABS_TEST_ID } from "@octopus-settings/constants/testIds/settingsPage";

import useTabs from "./useTabs";
import useStyles from "./Tabs.styles";

const Tabs = () => {
  const { classes } = useStyles();
  const { tabItems, activeTabIndex, handleTabChange } = useTabs();

  if (tabItems.length === 0) {
    return null;
  }

  return (
    <TabsComponent
      defaultSelectedTab={activeTabIndex}
      handleTabChange={handleTabChange}
      tabItems={tabItems}
      className={classes.tabs}
      data-testid={SETTINGS_TABS_TEST_ID}
    />
  );
};

export default Tabs;
